import React from "react";
import { FormLabel, Switch, Select } from "@chakra-ui/react";
import "./launchprot.css";

const LaunchProt = ({ formValues, setFormValues }) => {
  return (
    <div className="launchprot-holder">
      <div className="linethrough">LAUNCH + PROTECTION CONFIGS</div>
      <div className="two-section">
        <div className="section-one">
          <p>Anti-Bot Options</p>
          <div className="switches">
            <div className="sw1">
              <Switch
                id="open-trade"
                value={formValues.openTrade}
                onChange={(e) => {
                  setFormValues({ ...formValues, openTrade: !formValues.openTrade });
                }}
              />
              <FormLabel htmlFor="open-trade" mb="0">
                Do you want to open trade at launch?
              </FormLabel>
            </div>
            <div className="sw1">
              <Switch
                id="anitwhale"
                value={formValues.antiWhale}
                onChange={(e) => {
                  setFormValues({ ...formValues, antiWhale: !formValues.antiWhale });
                }}
              />
              <FormLabel htmlFor="anitwhale" mb="0">
                Anti-whale: Only one wallet is able to buy at on block.
              </FormLabel>
            </div>
            <div className="sw1">
              <Switch
                id="antibot"
                value={formValues.antiBot}
                onChange={(e) => {
                  setFormValues({ ...formValues, antiBot: !formValues.antiBot });
                }}
              />
              <FormLabel htmlFor="antibot" mb="0">
                Anti-Bot: Only less than 10 GWEI is valid for trade.
              </FormLabel>
            </div>
          </div>
        </div>
        <div className="section-two">
          <p>Anti-Bot:Restricts trade until the dedicated block.</p>
          <Select
            size="sm"
            value={formValues.antiBotBlock}
            onChange={(e) => {
              setFormValues({ ...formValues, antiBotBlock: !formValues.antiBotBlock });
            }}
          >
            <option value="option1">0 block (false)</option>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default LaunchProt;
